<template>
  <div class="nav-bar">
    <ul class="nav-list">
      <li v-for="item in navItems" :key="item.name" class="nav-item">
        <router-link :to="{ path: item.path, query: { keyword: item.city } }" class="nav-link" replace>{{
          item.name}}</router-link>
      </li>
    </ul>
    <div class="user-area">
      <div class="user-actions">
        <!-- 未登录状态 -->
        <div v-if="!isLoggedIn" class="auth-links">
          <router-link to="/Login">登录</router-link>
          <router-link to="/Register">注册</router-link>
        </div>
        <!-- 已登录状态 -->
        <div v-else class="user-info">
          <router-link :to="{ name: 'UserResource', query: { userName: this.userName, userId: this.userId } }" replace>
            <img :src="userAvatar" alt="" class="user-avatar">
          </router-link>
          <span class="user-name">{{ userName }}</span>
          <a href="#" @click.prevent="logout">退出</a>
        </div>
      </div>
      <span>投诉电话1010-6188</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NavBar',
  data() {
    const currentCity = localStorage.getItem('selectedCity');
    return {
      userId:'',
      userName: '',
      userAvatar: require('@/assets/登录头像.png'),
      navItems: [
        { name: '首页', path: '/' },
        { name: '二手房', path: '/PropertySearchResult', city: currentCity,keyword:currentCity },
        { name: '新房', path: '/NewPropertySearchResult', city: currentCity,keyword:currentCity },
        { name: '租房', path: '/RentSearchResult', city: currentCity,keyword:currentCity },
        { name: '小区', path: '/CommunitySearchResult', city: currentCity ,keyword:currentCity},
        { name: '发布房源', path: '/SellHouse', city: currentCity }
      ]
    };
  },
  computed: {
    isLoggedIn() {
      if (localStorage.getItem('id') != null && localStorage.getItem('name') != null) {
        this.userName = localStorage.getItem('name');
        this.userId = localStorage.getItem('id');
      }
      return localStorage.getItem('id') != null;
    }
  },
  methods: {
    logout() {
      if (confirm('确定要退出登录吗？')) {
        localStorage.clear();
        window.location.reload(); // 强制刷新整个页面
      }
    }
  }
};
</script>

<style scoped>
.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0f2e4e;
  color: #fff;
  padding: 0 20px;
  height: 40px;
}

.nav-list {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-item {
  margin-right: 20px;
}

.nav-link {
  color: white;
  text-decoration: none;
}

.nav-link:hover {
  text-decoration: underline;
}

.user-area {
  display: flex;
  gap: 20px;
}

.user-actions a {
  margin-left: 15px;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.3s;
  font-size: 14px;
}

.user-avatar {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 8px;
  vertical-align: middle;

}
</style>
